import { ViewConfig } from '@spartacus/storefront'

export const defaultSearchPageSize = 25

export const customViewConfig: ViewConfig = {
  view: {
    defaultPageSize: defaultSearchPageSize,
    infiniteScroll: {
      active: true,
      productLimit: 75,
      showMoreButton: true
    },
  },
}
